import type {Values} from "@wix/devzai-utils-common";

export const DoppeActionWidgetPopupMode = {
    InnerModal: 'InnerModal',
    FullScreenModal: 'FullScreenModal',
    InnerFullScreenModal: 'InnerFullScreenModal',
    Drawer: 'Drawer',
} as const;

export type DoppeActionWidgetPopupMode = Values<typeof DoppeActionWidgetPopupMode>;